import { axiosBase } from 'api/axios'
import type { TokenBalance } from 'models/investment'

/** The signed-in user's token holdings, per wallet and token. */
export const fetchTokenBalances = async (): Promise<TokenBalance[]> =>
  axiosBase
    .post<TokenBalance[]>('/wallets/tokenBalances')
    .then((response) => (Array.isArray(response.data) ? response.data : []))
